import { IPillVariant } from "@netfront/ui-library";
import { ProgressTrackerUserFlowStatusType } from "./UserProgressTable.interfaces";


const getFriendlyStatus = (status: ProgressTrackerUserFlowStatusType): string => {
  const statusMap: Record<ProgressTrackerUserFlowStatusType, string> = {
    AVAILABLE: 'Not started',
    COMPLETED: 'Completed',
    IN_PROGRESS: 'In progress',
    LOCKED: 'Locked',
    OVERDUE: 'Overdue'
  };

  return statusMap[status];
};

const getVariantByDates = ({ started, completed }: {completed?: string; started?: string }): IPillVariant => {
  let status: ProgressTrackerUserFlowStatusType = 'AVAILABLE';
  if (!started) status = 'AVAILABLE';
  if (started && !completed) status = 'IN_PROGRESS';
  if (completed) status = 'COMPLETED';

  return getUserFlowStatusVariant(status);
};


const getUserFlowStatusVariant = (status: ProgressTrackerUserFlowStatusType): IPillVariant => {

  const statusMap: Record<ProgressTrackerUserFlowStatusType, IPillVariant> = {
    AVAILABLE: 'default',
    COMPLETED: 'green',
    IN_PROGRESS: 'orange' as IPillVariant,
    LOCKED: 'default',
    OVERDUE: 'red',
  }

  return statusMap[status];

};

export { getFriendlyStatus, getVariantByDates, getUserFlowStatusVariant };